export const rhythmIds: { [key: string]: string } = {
    jhaptaalTheka: "8217d3ed-9ada-4391-b206-363a21a3ff92",
    roopakTheka: "0b5debdc-259c-4da2-8dcb-4e7c94489522",
    deepchandiTheka: "8b52d1fa-7de1-4db4-a393-3653b9b8bd6c",
    punjabiTheka: "78980acc-e586-42b1-9288-27b828a9b8bc",
};
